import { render, staticRenderFns } from "./PaymentEnd.vue?vue&type=template&id=2f5dc61a"
import script from "./PaymentEnd.vue?vue&type=script&lang=js"
export * from "./PaymentEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports